import { render, staticRenderFns } from "./SectionOurPartinars.component.vue?vue&type=template&id=f7592a76&"
import script from "./SectionOurPartinars.component.vue?vue&type=script&lang=js&"
export * from "./SectionOurPartinars.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports